export const AuthActions = {
    MsalContext: 'MsalContext',
}

export const AuthInfoActions = {
    GetProfile: 'GetProfile',
    Profile: 'Profile',
    IsProfileLoading: 'IsProfileLoading',
}